module.exports = __webpack_public_path__ + "components/country-flag/static/sv-1a27b26b8e2f1a30656bcfcfda1d3210.svg";